document.addEventListener('DOMContentLoaded', function() {
  console.log('Hello, Psihomo! <br> Mateo is doing a test!');
});

// Custom media query classes
function setBodyClass() {
  var width = window.innerWidth;
  if (width <= 768) {
    document.body.classList.add('mobile-view');
    document.body.classList.remove('desktop-view');
  } else {
    document.body.classList.add('desktop-view');
    document.body.classList.remove('mobile-view');
  }
}

// Custom section for animated text 
var animated_text = document.getElementById("scroll-text");

console.log(animated_text);

// Custom Fixed btn that sends the user to the top 🔝
document.addEventListener('DOMContentLoaded', function() {
  const backToTopButton = document.createElement('button');
  backToTopButton.innerText = '☝️';
  // Set the class name
  backToTopButton.className = 'back-to-top-btn';
  document.body.appendChild(backToTopButton);

  backToTopButton.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 500) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const delayedContent = document.querySelector('.delayed-content');
    delayedContent.style.display = 'block';
  }, 10000);
});

/* Temp code for thank you design template
if (hasCustomThankYou) {
            const thankYouStepElement = document.querySelector('div.step[data-step="thank_you"]');
              thankYouStepElement.innerHTML = `
                <div class="custom-thank-you">
                  <h2>Thank You for Purchasing Our Special Product!</h2>
                  <p>We appreciate your purchase and hope you enjoy it.</p>
                  <!-- Add more custom content here -->
                </div>
              `;
             const sidebar = document.querySelector('aside.sidebar');
              if (sidebar) {
                sidebar.remove();
              }
          }
          */

// ------------- Make code and logic for custom metafield template page -------------
/*
document.addEventListener('DOMContentLoaded', function() {
  // Remove the sidebar element
  const sidebar = document.querySelector('aside.sidebar');
  if (sidebar) {
    sidebar.remove();
  }

  // Function to get URL parameter
  function getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Check if current page is the thank you page
  if (document.querySelector('div.step[data-step="thank_you"]')) {
    const orderId = getParameterByName('id');

    if (orderId) {
      fetch(`/admin/orders/${orderId}.json`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '<YOUR_API_ACCESS_TOKEN>'
        }
      })
      .then(response => response.json())
      .then(data => {
        const order = data.order;
        let hasCustomThankYou = false;

        const metafieldPromises = order.line_items.map(item => {
          return fetch(`/admin/products/${item.product_id}/metafields.json`, {
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Access-Token': '<YOUR_API_ACCESS_TOKEN>'
            }
          })
          .then(response => response.json())
          .then(metafieldsData => {
            metafieldsData.metafields.forEach(metafield => {
              if (metafield.namespace === 'custom' && metafield.key === 'custom_thankyou_page' && metafield.value === 'thankyou') {
                hasCustomThankYou = true;
              }
            });
          });
        });

        Promise.all(metafieldPromises).then(() => {
          if (hasCustomThankYou) {
            const thankYouStepElement = document.querySelector('div.step[data-step="thank_you"]');
            if (thankYouStepElement) {
              thankYouStepElement.innerHTML += `
                <div class="custom-thank-you">
                  <h2>Thank You for Purchasing Our Special Product!</h2>
                  <p>We appreciate your purchase and hope you enjoy it.</p>
                  <!-- Add more custom content here -->
                </div>
              `;
            }
          }
        });
      })
      .catch(error => console.error('Error fetching order data:', error));
    }
  }
});
*/


